export const loadHotjar = () => {
    window.hj =
        window.hj ||
        function() {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
    window._hjSettings = { hjid: 2920342, hjsv: 6 };

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = 1;
    script.src =
        'https://static.hotjar.com/c/hotjar-' +
        window._hjSettings.hjid +
        '.js?sv=' +
        window._hjSettings.hjsv;
    head.appendChild(script);
};
